module.exports = __webpack_public_path__ + "static/media/21_tn.32859a0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/21_tn.jpg
// module id = 159
// module chunks = 0